const config = {
    "base_url":window?.location?.host.includes('localhost'||'127.0.0')?`https://127.0.0.1/api/`:`${window?.location?.protocol}//${window?.location?.host}/api/`,
    "redirection_url":window?.location?.host.includes('localhost'||'127.0.0')?`http://${window.location.host}`:`https://ostreon.io`
}
export default config
